var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('CarouselWidget',{staticClass:"slide-show-section",attrs:{"items":_vm.items,"itemsToShow":{
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },"gap":0,"nav":"","nav-inside":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
  var item = ref.item;
return [_c('img',{staticClass:"slide-show-section_img d-block",attrs:{"src":item.img,"width":"100%"}})]}}],null,false,551423794)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }